import { useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { NEWS_BOARD_INFO, NEWS_BOARD_INFO_TAB, NEWS_BOARD_INFO_MOBILE } from 'assets/json/newsInfo.js'
import './NewsMain.scss'
import { useMediaQuery } from 'react-responsive'

/**
 * @file 최신소식 게시글 상세화면
 */
function NewsBoardDetail() {
    const [boardInfo, setBoardInfo] = useState({}) //게시글 data
    const location = useLocation()

    const isMobile = useMediaQuery({ maxWidth: 768 })
    const isTab = useMediaQuery({ maxWidth: 1279 })

    const newsBoardInfo = isMobile ? NEWS_BOARD_INFO_MOBILE : isTab ? NEWS_BOARD_INFO_TAB : NEWS_BOARD_INFO

    useEffect(() => {
        let id = Number(new URLSearchParams(location.search).get('id')) //board board Id

        newsBoardInfo?.map(val => {
            if (val.id === id) {
                setBoardInfo(val)
                return false
            }
        })
    }, [location, newsBoardInfo])

    return <div dangerouslySetInnerHTML={{ __html: boardInfo.contents }}></div>
}

export default NewsBoardDetail
